export default __webpack_public_path__ + "f6ceaaa.png";